<style lang="less">
	@import './home.less';
</style>
<template>
	<div class="m_main_content">
		<el-container style="display: flex;">
			<el-aside :width="!isCollapse ? '200px' :'60px'">
				<side :isCollapse="isCollapse"></side>
			</el-aside>
			<el-container style="width:calc(100% - 200px)">
				<el-header>
					<ar-header @changeFold="changeFold"></ar-header>
				</el-header>
				<el-main>
					<div class="m_index_navbar_content" ref="scrollCon" @DOMMouseScroll="handlescroll" @mousewheel="handlescroll">
						<ar-tabbar :tagBodyLeft="tagBodyLeft"></ar-tabbar>
					</div>
					<div class="m_index_main_content">
						<router-view/>
					</div>
				</el-main>
			</el-container>
		</el-container>
	</div>

</template>

<script>
	import Side from '@/components/Side/index.vue';
	import ArHeader from '@/components/Header/index.vue';
	import ArTabbar from '@/components/Tabbar/index.vue';
	import storage from '@/utils/storage'
	export default {
		components: {
			Side,
			ArHeader,
			ArTabbar
		},
		
		data() {
			return {
				isCollapse: false,
				tagBodyLeft: 0,
				token: storage.get('token')
			}
		},
		computed: {
			userInfo() {
		        return this.$store.state.member.userInfo;
		   },
		},
		created() {
			if(this.userInfo != null && this.token != null){
				if(this.$route.path =='/'){
					window.location.href='/#/main';
				}
			}else{
				storage.remove('token');
				storage.remove('userInfo');
				window.location.href='/#/login';
			}
			
		},
		mounted() {
  		},
		methods: {
			changeFold(item) {
				this.isCollapse = item;
			},
			handlescroll(e) {
				var type = e.type;
				let delta = 0;
				if(type === 'DOMMouseScroll' || type === 'mousewheel') {
					delta = (e.wheelDelta) ? e.wheelDelta : -(e.detail || 0) * 40;
				}
				let left = 0;
				if(delta > 0) {
					left = Math.min(0, this.tagBodyLeft + delta);
				} else {
//					console.log(this.$refs.scrollCon.offsetWidth)
//					console.log(this.$refs.scrollCon.children[0].offsetWidth)
					if(this.$refs.scrollCon.offsetWidth  < this.$refs.scrollCon.children[0].offsetWidth) {
						if(this.tagBodyLeft < -(this.$refs.scrollCon.children[0].offsetWidth - this.$refs.scrollCon.offsetWidth )) {
							left = this.tagBodyLeft;
						} else {
							left = Math.max(this.tagBodyLeft + delta, this.$refs.scrollCon.offsetWidth - this.$refs.scrollCon.children[0].offsetWidth );
						}
					} else {
						this.tagBodyLeft = 0;
					}
				}
				this.tagBodyLeft = left;
			}
		}
	}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/Home/index.vue